module.exports = __webpack_public_path__ + "media/images/carrinho_icone_20_20-cf611e27588d1050ffea7882359404f7.png";